//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapState} from "vuex";
export default {
  data: function() {
    return {
      selectedProcessId: undefined
    }
  },
  name: "ProcessList",
  props: ['processRoot', 'label', 'value', 'processes'],
  methods: {
    selectProcess: function(process) {
      console.log('Select process')
      this.$emit("input", process)
    }
  },
  computed: {
    ...mapState(['processesLoading', 'rootProcesses']),
    ...mapGetters(['getChildProcesses'])
  },
  watch: {
    value(process) {
      this.selectedProcessId = process ? process.id : undefined
    }
  }
}
